export const chartOptionsStackedMixin = {
    data: function() {
        return {
            chartOptions: {
                chart: {
                  type: "column",
                  backgroundColor: "transparent",
                },
                exporting: {
                  enabled: true
                },
                title: {
                  text: "",
                  style: {
                    color: "white",
                    display: ""
                  }
                },
                subtitle: {
                  text: "",
                  style: {
                    color: "white",
                    display: ""
                  }
                },
                xAxis: {
                  type: "category",
                  labels: {
                    style: {
                      color: "white"
                    }
                  }
                },
                yAxis: {
                  title: {
                    text: "Percentage Of Total"
                  },
                  stackLabels: {
                    enabled: false,
                    formatter: function() {
                      return "Total: " + this.total;
                    },
                    style: {
                      fontWeight: "bold",
                      color: "white"
                    }
                  }
                },
                legend: {
                  enabled: false
                },
                tooltip: {
                  headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                  pointFormat: "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
                },
                plotOptions: {
                  column: {
                    stacking: "normal",
                    dataLabels: {
                      enabled: false,
                      formatter: function() {
                        return "TEST";
                      }
                    }
                  },
                  series: {
                    dataLabels: {
                      enabled: false,
                      format: "{point.name}: {point.y:.1f}%",
                      color: "white",
                      style: {
                        textOutline: false
                      }
                    },
                    point: {
                      events: {
                        click: ({ point }) => {
                          console.log(point);
                        }
                      }
                    }
                  }
                },
                drilldown: {
                  activeAxisLabelStyle: {
                    textDecoration: "none",
                    color: "white"
                  },
                  activeDataLabelStyle: {
                    color: "white"
                  }
                },
                series: []
            }
        }
    }
}